<div id="crm-partner-salesperson-form" *ngIf="readOnly; else formField">
  <div class="crm-field-label">Salesperson</div>
  <div class="crm-field-value">
    <!-- ng-container necessary since Angular interpolation will add empty space -->
    <ng-container *ngIf="salespersonName() as salespersonName; else loading">
      <ng-container *ngIf="salespersonName !== NO_VALUE_FOR_SALESPERSON">
        {{ salespersonName }}
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  </div>
</div>
<ng-template #formField>
  <glxy-form-field *ngIf="!loadingValues(); else loadingField">
    <glxy-label>Salesperson</glxy-label>
    <input
      type="text"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
      data-testid="form-salesperson-input"
      [placeholder]="'Add salesperson...'"
      (blur)="saveField()"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn(availableOptions())">
      <mat-option *ngFor="let option of filteredOptions()" [value]="option" (mousedown)="$event.preventDefault()">
        {{ option?.displayName }}
      </mat-option>
    </mat-autocomplete>
  </glxy-form-field>
  <ng-template #loadingField>
    <glxy-form-field>
      <glxy-label>Salesperson</glxy-label>
      <input type="text" disabled matInput />
      <mat-spinner matPrefix diameter="24"></mat-spinner>
    </glxy-form-field>
  </ng-template>
</ng-template>
